import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withDropdown from 'utils/withDropdown';
import StorageMartNavLinkToggle from '../StorageMartNavLinkToggle';
import styles from './styles.scss';

const propTypes = {
  forwardedRef: PropTypes.object.isRequired,
  item: PropTypes.shape({
    navigationItems: PropTypes.arrayOf(PropTypes.object),
    key: PropTypes.string.isRequired,
    page: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
    text: PropTypes.string,
    link: PropTypes.shape({
      target: PropTypes.string,
      href: PropTypes.string,
    }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  visible: PropTypes.bool,
  className: PropTypes.object,
  closeMobileNav: PropTypes.func,
};

const defaultProps = {
  visible: undefined,
};

class StorageMartNavItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
      show: false,
    };
  }

  componentDidUpdate() {
    const { show } = this.state;
    const { visible } = this.props;

    // Collapse nested nav menus when the parent nav is closed.
    if (!visible && show) {
      this.setState({ show: false });
    }
  }

  onFocus = () => this.setState({
    focused: true,
  })

  onBlur = () => this.setState({
    focused: false,
  })

  onClick = () => this.setState(prevState => ({
    show: !prevState.show,
  }))

  render() {
    const { forwardedRef, item, visible, className, closeMobileNav } = this.props;
    const { focused } = this.state;
    const { navigationItems } = item;

    // Top level nav items use the `show` prop passed down from the `withDropdown`
    // HOC, while nested nav items maintain their own state.
    const show = this.props.show || this.state.show;
    const onClick = this.props.onClick || this.onClick;

    const hasChildren = !!(navigationItems && navigationItems.length);
    const isVisible = this.props.show || (visible && this.state.show);

    const itemClassNames = cx(
      styles.item,
      show && styles.show,
      focused && styles.focused,
      hasChildren && styles.hasChildren,
      className,
    );

    return (
      <li className={itemClassNames} ref={forwardedRef}>
        <StorageMartNavLinkToggle
          item={item}
          show={show}
          onToggle={onClick}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          toggleClassName={styles.toggle}
          componentClassName={styles.link}
          closeMobileNav={closeMobileNav}
        />
        {hasChildren && (
          <ul className={cx(styles.menu)}>
            {navigationItems.map(child => (
              <StorageMartNavItem
                key={child.text || (child.page && child.page.title)}
                item={child}
                visible={isVisible}
                closeMobileNav={closeMobileNav}
              />
            ))}
          </ul>
        )}
      </li>
    );
  }
}

StorageMartNavItem.propTypes = propTypes;
StorageMartNavItem.defaultProps = defaultProps;

export default withDropdown(React.forwardRef((props, ref) => (
  <StorageMartNavItem {...props} forwardedRef={ref} />
)));
